import React from 'react'
import { ToCartCommonComponent } from '../to_cart_common/to_cart_common.component'
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component'
import { sharedData } from '../../../models/shared_data'

export class CartThumbComponent extends ToCartCommonComponent {
  needUnitsInfo() {
    const it = this.props.params
    return it.price_unit && it.price_unit != '' && it.price_one && it.price_one != 0
  }

  render() {
    const it = this.props.params
    const price = this.currentPrice()
    const symbol = sharedData.currency_symbol

    if(this.state.inCart > 0)
      return (
        <div className="item-thumb-cart">
          <div className="item-thumb-cart-base-price">
            { this.needUnitsInfo() &&
              <div className="item-thumb__price_one">
              { it.price_one } {symbol}/{ it.price_one_unit }, &nbsp;
              </div>
            }

            <CurFormatComponent price={ price }/>

            { this.needUnitsInfo() &&
              <span>/{it.price_unit}</span>
            }
          </div>
          <div className="item-show-price item-show-price--no-padding">
            <div className="item-show-price-incart">
              <div className="item-show-price-incart__wrapper">
                <a className="down" href="" onClick={this.down}>-</a>
                <span className="item-show-price-incart__count">
                  {this.state.quantity}
                </span>
                <a className="up" href="" onClick={this.up}>+</a>
              </div>
            </div>
          </div>
          <div className="item-thumb-cart-full-price">

            <CurFormatComponent price={ price * this.state.quantity  }/>

          </div>
        </div>
      )

    return (
      <div className="item-thumb__price">
        <button className="btn btn--blue" onClick={this.toCart}>
          <CurFormatComponent price={ price }/>
        </button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/cart_thumb/cart_thumb.component.jsx